<template>
    <div v-if="billingStore.subscriptionLoading">
        <!-- loading -->
        <b-card>
            <div >
                <h3>Subscription</h3>
            </div>
        </b-card>
    </div>
    <div v-else>
        <b-card v-if="billingStore.subscriptionPlan.showSubview">
            <div v-if="billingStore.subscriptionPlan.canceled !=true">
                <h3>Subscription</h3>
                <div class="d-flex justify-content-between align-items-start mb-1">
                    <span
                        class="badge bg-light-warning text-sm"
                        style="font-size:11px;"
                        v-if="billingStore.subscriptionPlan.user_subscription_ended"
                    >
                        {{ billingStore.subscriptionPlan.my_plan }}
                    </span>
                    <span class="badge bg-light-primary text-sm" style="font-size:11px;" v-else>
                        {{ billingStore.subscriptionPlan.plan }}
                    </span>
                    <div>
                        <div v-if="billingStore.subscriptionPlan.activeDiscount != null">
                            <span class="badge bg-light-primary text-sm" style="font-size:11px;">
                                Active Discount: {{billingStore.subscriptionPlan.activeDiscount}}
                            </span>
                        </div>
                        <div v-if="billingStore.subscriptionPlan.coupon != null">
                            <span class="badge bg-light-primary text-sm" style="font-size:11px;">
                                Coupon Code : {{billingStore.subscriptionPlan.coupon.name}} 
                                {{billingStore.subscriptionPlan.coupon.value}}
                            </span>
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-between mb-1" v-if="!billingStore.subscriptionPlan.user_subscription_ended">
                    <div class="badge bg-light-primary text-sm" style="font-size:11px;">
                        {{ billingStore.subscriptionPlan.plan.title }}
                    </div>
                </div>
                <div class="d-flex justify-content-start mb-1">
                    <sup class="h5 pricing-currency text-primary mt-0 mb-0"></sup>
                    <span class="display-5 mb-0 text-primary" style="font-weight:bolder;">{{billingStore.subscriptionPlan.subscriptionAmount}}</span>
                    <span>/</span>
                    <span>month</span>
                </div>
                <ul class="ps-1 mb-2">
                    <li class="mb-50" v-if="billingStore.subscriptionPlan.canceled">
                        <template v-if="billingStore.subscriptionPlan.nextPaymentAttempt !== 0">
                            <h5 style="font-weight:bolder;">
                                Subscription ends on {{billingStore.subscriptionPlan.nextPaymentAttempt}}
                            </h5>
                        </template>
                        <template v-else>
                            <h5 style="font-weight:bolder;">
                                Subscription Is Inactive
                            </h5>
                        </template>
                    </li>
                    <li class="mb-50" v-else><h5 style="font-weight:bolder;">Plan Renews On {{billingStore.subscriptionPlan.nextPaymentAttempt}}</h5></li>
                    <!-- <li class="mb-50">We will send you a notification upon subscription expiration</li> -->
                </ul>
                <div class="d-flex justify-content-between align-items-center fw-bolder mb-50">
                    <span>Days</span>
                    <span>{{billingStore.subscriptionPlan.paymentBar.subDifference}} of {{billingStore.subscriptionPlan.paymentBar.totalDay}} Days</span>
                </div>
                <div class="progress mb-50" style="height: 8px">
                    <div
                        class="progress-bar"
                        role="progressbar"
                        :style="{width:billingStore.subscriptionPlan.paymentBar.percentageDate+'%'}"
                        aria-valuenow="65"
                        aria-valuemax="100"
                        aria-valuemin="80"
                    ></div>
                </div>
                <span v-if="billingStore.subscriptionPlan.canceled">
                    <span>Subscription Has Ended.</span>
                </span>
                <!-- <span v-else-if="canceled==''">{{paymentBar.remainingDate}} days remaining until renewal.</span> -->
                <span v-else>
                    <span v-if="billingStore.subscriptionPlan.paymentBar.remainingDate > 0">
                        {{ billingStore.subscriptionPlan.paymentBar.remainingDate }} days remaining until renewal
                    </span>
                    <span v-else>Subscription Has Ended.</span>
                </span>
                <div class="d-grid w-100 mt-2">
                    <a :href="billingStore.subscriptionPlan.billingPortal" class="btn btn-primary waves-effect waves-float waves-light col-12" data-bs-target="#upgradePlanModal" data-bs-toggle="modal" v-if="billingStore.subscriptionPlan.canceled">
                        Billing Portal
                    </a>
                    <div v-else>
                        <div v-if="billingStore.subscriptionPlan.plan == 'On Trial'">
                            <a :href="billingStore.subscriptionPlan.billingPortal" class="btn btn-primary waves-effect waves-float waves-light col-12 mt-2">
                                Billing Portal
                            </a>
                        </div>
                        <div v-else>
                            <a :href="billingStore.subscriptionPlan.billingPortal" class="btn btn-primary waves-effect waves-float waves-light col-12 mt-2">
                                Billing Portal
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <!-- show user view that canceled -->
            <div v-else>
                <h4 class="mb-2" style="font-weight:bolder;">
                    Canceled Subscription
                </h4>
                <div class="d-flex justify-content-between align-items-start mb-1">
                    <span class="badge bg-light-primary text-sm" style="font-size:11px;">
                        {{ billingStore.subscriptionPlan.plan.title }}
                    </span>
                </div>
                <div class="d-flex justify-content-start mb-1">
                    <sup class="h5 pricing-currency text-primary mt-0 mb-0"></sup>
                    <span class="display-5 mb-0 text-primary" style="font-weight:bolder;">{{billingStore.subscriptionPlan.subscriptionAmount}}</span>
                    <span>/</span>
                    <span>month</span>
                </div>
                <h5 style="font-weight:bolder;">
                    Your Subscription Ends On:
                </h5>
                <h6>
                    {{ billingStore.subscriptionPlan.endsAt }}
                </h6>
                <a
                    :href="billingStore.subscriptionPlan.billingPortal"
                    class="btn btn-primary waves-effect waves-float waves-light col-12 mt-2"
                    data-bs-target="#upgradePlanModal"
                    data-bs-toggle="modal"
                    v-if="billingStore.subscriptionPlan.canceled"
                >
                    Billing Portal
                </a>
            </div>
            <!-- end show user view that canceled -->
        </b-card>
        <b-card v-else-if="billingStore.subscriptionPlan.has_incomplete_payment">
            <a
                :href="billingStore.subscriptionPlan.billingPortal"
                class="btn btn-primary waves-effect waves-float waves-light col-12 mt-2"
                target="_blank"
            >
                Billing Portal
            </a>
        </b-card>
        <b-card v-else>
            <div class="d-flex justify-content-center align-items-start mb-1">
                <h2 class="badge bg-light-warning " style="font-size:16px;">No Active Trial or Subscription.</h2>
            </div>
            <router-link
                :to="{ name: 'billing-plans'}"
                class="btn btn-primary waves-effect waves-float waves-success col-12 mt-2"
            >
                Creditfixrr Plans
            </router-link>
        </b-card>
    </div>
</template>

<script>
import {useBillingStore} from '../../stores/BillingStore'
export default {
    setup(){
       const billingStore = useBillingStore();
       return{
            billingStore,
       }
    },
    beforeMount(){
        this.billingStore.getSubscriptionPlan()

    },
}
</script>
